import { useTranslation } from 'react-i18next'
import { Column } from 'primereact/column'
import DataTable from '../../../components/ui/DataTable'
import EmptyState from '../../../components/ui/EmptyState'
import type { MeetingParticipant } from '../types'

interface Props {
  /** Bölüm başlığı. */
  title: string
  people: MeetingParticipant[]
  emptyTitle: string
  emptyDesc: string
  isLoading: boolean
  /** Dar ekran (≤CARD_VIEW_BREAKPOINT) → tablo yerine kart listesi. */
  isMobile: boolean
}

/**
 * Toplantı detayında salt-okuma kişi listesi — katılımcılar ve dağıtım listesi (119) aynı görünümü
 * paylaşır. Dar ekranda tablo yerine kart listesi (ActionNoteCards ile aynı desen; tıklanamaz, işlemsiz).
 */
export default function MeetingPeopleList({
  title,
  people,
  emptyTitle,
  emptyDesc,
  isLoading,
  isMobile,
}: Readonly<Props>) {
  const { t, i18n } = useTranslation()
  const jobTitle = (p: MeetingParticipant) =>
    (i18n.language === 'en' ? p.jobTitleEn : p.jobTitleTr) ?? p.jobTitleTr ?? ''
  const empty = <EmptyState icon="pi pi-users" title={emptyTitle} description={emptyDesc} />

  return (
    <div className="minutes-subsection">
      <h3 className="minutes-subhead">{title}</h3>
      {isMobile ? (
        /* Yükleme biterken boş-durum gösterilmez: veri gelmeden liste boş olduğu için aksi hâlde
           önce boş-durum yanıp sönerdi. Masaüstü dalı bunu `loading` ile zaten yapıyor. */
        !isLoading && people.length === 0 ? (
          empty
        ) : (
          <div className="ui-card-list mtg-participant-cards">
            {people.map((p) => (
              <div key={p.employeeId} className="ui-card">
                <div className="ui-card-head">
                  <span className="ui-card-title">{p.fullName}</span>
                </div>
                <span className="ui-card-sub">{p.employeeId}</span>
                <div className="ui-card-row">{jobTitle(p)}</div>
              </div>
            ))}
          </div>
        )
      ) : (
        <DataTable
          value={people}
          loading={isLoading}
          dataKey="employeeId"
          paginator={false}
          emptyMessage={empty}
        >
          <Column
            header={t('meetings.detail.participants.name')}
            body={(p: MeetingParticipant) => <span className="minutes-cell-strong">{p.fullName}</span>}
          />
          <Column
            header={t('meetings.detail.participants.sicil')}
            body={(p: MeetingParticipant) => p.employeeId}
          />
          <Column header={t('meetings.detail.participants.jobTitle')} body={jobTitle} />
        </DataTable>
      )}
    </div>
  )
}
